import axios from 'axios';

import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';
import type { Covid19SettingsOrgDoc } from '@bb/domain/dist/schemas';

export type SaveCovid19OrgSettingsResponse =
  BuildJsonType<Covid19SettingsOrgDoc>;

const saveCovid19OrgSettings = async (settings: Covid19SettingsOrgDoc) => {
  const { data: covid19Settings } =
    await axios.post<SaveCovid19OrgSettingsResponse>(
      `/covid19/org/settings`,
      settings,
    );

  return covid19Settings;
};

export default saveCovid19OrgSettings;
